import { AddOutlined, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import * as lodash from "lodash";
import React, { useEffect, useState } from "react";
import { useRecordContext } from "react-admin";
import { useFormContext } from "react-hook-form";
import { userApi as api } from "../../url";
import "./fileInputStyle.css";

export const FileInput = ({
  title = "Upload File",
  edit = false,
  resource,
  value,
  route = "event/upload",
  field,
  resourceField,
  add,
  onFormUpload,
  source,
  width = "600px",
  height = "500px",
  ...props
}) => {
  const b = useFormContext();
  const c = useRecordContext(props);

  const [files, setFiles] = useState(
    value ?? (c ? c[`${source}`] : [{ url: "", name: "", reference: "" }]),
  );

  const handleFileUpload = async (e, i) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    await fetch(`${api}/${route}`, {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Access-Control-Allow-Origin": "*",
      }),
      body: formData,
    })
      .then((res) => res.json())
      .then((body) => {
        if (!body.error) {
          const copy = [...files];
          copy[i] = {
            link: body?.file?.link,
            name: body?.file.name,
            reference: copy?.[i]?.reference ?? "",
          };
          setFiles(copy);
        }
      });
  };
  const addFile = () => {
    setFiles([...files, { url: "", name: "", reference: "" }]);
  };

  useEffect(() => {
    if (onFormUpload) {
      onFormUpload(files);
      return;
    }
    if (b && b.setValue) {
      b.setValue(source ?? "images", files, { shouldDirty: true });
    }
  }, [files]);

  return (
    <div>
      <h3>{title}</h3>
      {(files ?? [{ url: "", name: "", reference: "" }]).map((file, index) => {
        return (
          <React.Fragment key={index}>
            {edit && (
              <IconButton
                onClick={() => {
                  const copy = [...files];
                  copy[index] = { url: "", name: "", reference: "" };
                  setFiles(copy);
                }}
              >
                {" "}
                <Edit />
              </IconButton>
            )}
            {edit && (
              <IconButton
                onClick={() => {
                  const copy = [...files];
                  copy.splice(index, 1);
                  setFiles(copy);
                }}
              >
                {" "}
                <Delete />
              </IconButton>
            )}
            {!file.link ? (
              <>
                {add || edit ? (
                  <label className="fileInput" value="">
                    <input
                      type="file"
                      onChange={(e) => handleFileUpload(e, index)}
                      accept="image/*, application/pdf"
                    />
                    Upload
                  </label>
                ) : (
                  <p>....</p>
                )}
              </>
            ) : /(.pdf)$/.test(file.name) ? (
              <div className="file">
                <iframe src={file.link} width={width} height={height}></iframe>
              </div>
            ) : (
              <div className="file">
                <img
                  src={file.link}
                  width={width}
                  height={height}
                  style={{ objectFit: "cover" }}
                ></img>
              </div>
            )}
          </React.Fragment>
        );
      })}
      <br />
      {add && (
        <Button onClick={addFile} startIcon={<AddOutlined />}>
          {" "}
          Add
        </Button>
      )}
    </div>
  );
};

export const FileInputSingle = ({
  title = "Upload File",
  edit = false,
  source,
  resource,
  route,
  field,
  resourceField,
  add,
  width = "600px",
  height = "500px",
  ...props
}) => {
  const b = useFormContext();
  const c = useRecordContext(props);
  const [files, setFiles] = useState([
    { link: c?.[source], name: c?.[source], reference: "" },
  ]);

  const handleFileUpload = async (e, i) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    const response = await fetch(`${api}/event/upload`, {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Access-Control-Allow-Origin": "*",
        type: "admin",
      }),
      body: formData,
    })
      .then((res) => res.json())
      .then((body) => {
        if (!body?.error) {
          const copy = [...files];
          copy[i] = {
            link: body.file?.link,
            name: body.file.name,
            reference: copy?.[i]?.reference ?? "",
          };
          setFiles(copy);
        }
      });
  };
  const addFile = () => {
    setFiles([...files, { link: "", name: "", reference: "" }]);
  };
  const handleReferenceChange = (index) => {
    return (e) => {
      const copy = [...files];
      copy[index] = { ...copy[index], reference: e.target.value };
      setFiles(copy);
    };
  };
  useEffect(() => {
    if (b && b.setValue) {
      b.setValue(source ?? "image", files[0].link, { shouldDirty: true });
    }
  }, [files]);

  return (
    <div>
      <h3>{title}</h3>
      {(files ?? [{ link: "", name: "", reference: "" }]).map((file, index) => {
        return (
          <React.Fragment key={index}>
            {edit && (
              <IconButton
                onClick={() => {
                  const copy = [...files];
                  copy[index] = { ...copy[index], link: "", name: "" };
                  setFiles(copy);
                }}
              >
                {" "}
                <Edit />
              </IconButton>
            )}
            {!file.link ? (
              <label className="fileInput" value="">
                <input
                  type="file"
                  onChange={(e) => handleFileUpload(e, index)}
                  accept="image/*, application/pdf"
                />
                Upload
              </label>
            ) : /(.pdf)$/.test(file.name) ? (
              <div className="file">
                <iframe src={file.link} width={width} height={height}></iframe>
              </div>
            ) : (
              <div className="file">
                <img
                  src={file.link}
                  width={width}
                  height={height}
                  style={{ objectFit: "cover" }}
                ></img>
              </div>
            )}
          </React.Fragment>
        );
      })}
      <br />
      {add && (
        <Button onClick={addFile} startIcon={<AddOutlined />}>
          {" "}
          Add
        </Button>
      )}
    </div>
  );
};

export const FileInputSingleForBanner = ({
  title = "Upload File",
  edit = false,
  source,
  resource,
  route,
  width = "600px",
  height = "500px",
  field,
  resourceField,
  add,
  ...props
}) => {
  const b = useFormContext();
  const c = useRecordContext(props);
  // const f = lodash.get(c, source, '');
  // console.log("f", c, source, f);
  var v = c ? c["value"] : undefined;
  if (typeof v == "string") {
    v = JSON.parse(v);
  }

  console.log("c", c);

  const [files, setFiles] = useState([v?.bannerUrl ?? ""]);

  const handleFileUpload = async (e, i) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    const response = await fetch(`${api}/appSettings/uploadBanners`, {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Access-Control-Allow-Origin": "*",
        type: "admin",
      }),
      body: formData,
    })
      .then((res) => res.json())
      .then((body) => {
        if (!body?.error) {
          const copy = [...files];
          copy[i] = body.file?.link;
          setFiles(copy);
        }
      });
  };
  const addFile = () => {
    setFiles([...files, ""]);
  };
  const handleReferenceChange = (index) => {
    return (e) => {
      const copy = [...files];
      copy[index] = { ...copy[index], reference: e.target.value };
      setFiles(copy);
    };
  };
  useEffect(() => {
    if (b && b.setValue) {
      b.setValue(source ?? "image", files[0], { shouldDirty: true });
    }
  }, [files]);

  return (
    <div>
      <h3>{title}</h3>
      {(files ?? [""]).map((file, index) => {
        return (
          <React.Fragment key={index}>
            {edit && (
              <IconButton
                onClick={() => {
                  const copy = [...files];
                  copy[index] = "";
                  setFiles(copy);
                }}
              >
                {" "}
                <Edit />
              </IconButton>
            )}
            {!file ? (
              <label className="fileInput" value="">
                <input
                  type="file"
                  onChange={(e) => handleFileUpload(e, index)}
                  accept="image/*, application/pdf"
                />
                Upload
              </label>
            ) : /(.pdf)$/.test(file) ? (
              <div className="file">
                <iframe src={file} width={width} height={height}></iframe>
              </div>
            ) : (
              <div className="file">
                <img
                  src={file}
                  width={width}
                  height={height}
                  style={{ objectFit: "cover" }}
                ></img>
              </div>
            )}
          </React.Fragment>
        );
      })}
      <br />
      {add && (
        <Button onClick={addFile} startIcon={<AddOutlined />}>
          {" "}
          Add
        </Button>
      )}
    </div>
  );
};

export const FileInputSingleLarge = ({
  title = "Upload File",
  edit = false,
  source,
  resource,
  width = "600px",
  height = "500px",
  route,
  field,
  resourceField,
  add,
  ...props
}) => {
  const b = useFormContext();
  const c = useRecordContext(props);
  const f = lodash.get(c, source, "");
  console.log("f", c, source, f);
  var v = c ? c[source] : "";
  // if (typeof v == 'string') {
  //   v = JSON.parse(v);
  // }
  const [files, setFiles] = useState([v]);

  const handleFileUpload = async (e, i) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    const response = await fetch(`${api}/parent/uploadLargeFiles`, {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Access-Control-Allow-Origin": "*",
        type: "admin",
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        filename: e.target.files[0].name,
        type: e.target.files[0].type,
      }),
    })
      .then((res) => res.json())
      .then(async (body) => {
        if (!body?.error) {
          // console.log("body.url", body )
          if (body?.url) {
            const response = await fetch(body?.url, {
              method: "PUT",
              headers: {
                "Content-Type": e.target.files[0].type,
              },
              body: e.target.files[0],
            });
            // const uploadData  = await response.json()

            if (response.status == 200) {
              const copy = [...files];
              copy[i] = body?.link;
              setFiles(copy);
            }
          }
        }
      });
  };
  const addFile = () => {
    setFiles([...files, ""]);
  };
  const handleReferenceChange = (index) => {
    return (e) => {
      const copy = [...files];
      copy[index] = { ...copy[index], reference: e.target.value };
      setFiles(copy);
    };
  };
  useEffect(() => {
    if (b && b.setValue) {
      b.setValue(source ?? "image", files[0], { shouldDirty: true });
    }
  }, [files]);

  return (
    <div>
      <h3>{title}</h3>
      {(files ?? [""]).map((file, index) => {
        return (
          <React.Fragment key={index}>
            {edit && (
              <IconButton
                onClick={() => {
                  const copy = [...files];
                  copy[index] = "";
                  setFiles(copy);
                }}
              >
                {" "}
                <Edit />
              </IconButton>
            )}
            {!file ? (
              <label className="fileInput" value="">
                <input
                  type="file"
                  onChange={(e) => handleFileUpload(e, index)}
                  accept="image/*, application/pdf, video/*"
                />
                Upload
              </label>
            ) : /(.pdf)$/.test(file) ? (
              <div className="file">
                <iframe src={file} width="600px" height="600px"></iframe>
              </div>
            ) : isImageFile(file) ? (
              <div className="file">
                <img
                  src={file}
                  width={width}
                  height={height}
                  style={{ objectFit: "cover" }}
                ></img>
              </div>
            ) : isVideoFile(file) ? (
              <div className="file">
                <video width={width} height={height} controls>
                  <source src={file} type="video/mp4" />
                </video>
              </div>
            ) : (
              <div className="file">
                <a href={file} target="_blank">
                  {file}
                </a>
              </div>
            )}
          </React.Fragment>
        );
      })}
      <br />
      {add && (
        <Button onClick={addFile} startIcon={<AddOutlined />}>
          {" "}
          Add
        </Button>
      )}
    </div>
  );
};

function isImageFile(file) {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(file);
}

function isVideoFile(file) {
  return /\.(mp4|mov|webm)$/.test(file);
}
